import React, { useState } from 'react';
import './index.css';
import Navigation from './components/Navigation';
import Sidebar from './components/Sidebar';
import HomePage from './pages/HomePage';
import ComponentPage from './pages/ComponentPage';
import GettingStarted from './pages/GettingStarted';

const APP_DATA = {
  components: [
    { id: 'text', name: 'Text', category: 'Basic' },
    { id: 'button', name: 'Button', category: 'Basic' },
    { id: 'textinput', name: 'TextInput', category: 'Basic' },
    { id: 'switch', name: 'Switch', category: 'Forms' },
    { id: 'checkbox', name: 'Checkbox', category: 'Forms' },
    { id: 'chip', name: 'Chip', category: 'Selection' },
    { id: 'toast', name: 'Toast', category: 'Feedback' },
    { id: 'alert', name: 'Alert', category: 'Feedback' },
    { id: 'dialog', name: 'Dialog', category: 'Feedback' },
    { id: 'bottomsheet', name: 'BottomSheet', category: 'Overlay' },
    { id: 'divider', name: 'Divider', category: 'Utilities' },
    { id: 'screenwrapper', name: 'ScreenWrapper', category: 'Layout' },
    { id: 'animatedinput', name: 'AnimatedInput', category: 'Advanced' },
    { id: 'buttongroup', name: 'ButtonGroup', category: 'Advanced' },
    { id: 'selector', name: 'Selector', category: 'Selection' },
  ]
};

function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedComponent, setSelectedComponent] = useState(null);

  const handleNavigate = (page, component = null) => {
    setCurrentPage(page);
    if (component) {
      setSelectedComponent(component);
    }
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage onNavigate={handleNavigate} />;
      case 'getting-started':
        return <GettingStarted />;
      case 'component':
        return <ComponentPage component={selectedComponent} onNavigate={handleNavigate} />;
      default:
        return <HomePage onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="app">
      <Navigation onNavigate={handleNavigate} />
      <div className="app-container">
        <Sidebar 
          components={APP_DATA.components} 
          currentComponent={selectedComponent}
          onComponentSelect={(comp) => handleNavigate('component', comp)}
        />
        <main className="main-content">
          {renderPage()}
        </main>
      </div>
    </div>
  );
}

export default App;
